import { cn } from '~/lib/cn';

export interface FieldBlockProps {
  label: string;
  className?: string;
  children: React.ReactNode;
}

export function FieldBlock({ label, className, children }: FieldBlockProps) {
  const _label = label ? `${label}:` : '';

  return (
    <div
      data-testid="field-block"
      className={cn('mb-lg flex items-center', className)}
    >
      <p className="mr-sm whitespace-nowrap text-body-xs">{_label}</p>
      <div className="max-w-[18em] truncate text-body-xs font-bold">
        {children}
      </div>
    </div>
  );
}

FieldBlock.displayName = 'FieldBlock';

export interface FieldValueProps {
  label: string;
  value: string;
  className?: string;
}

export function FieldValue({ label, value, className }: FieldValueProps) {
  return (
    <div
      data-testid="field-value"
      className={cn('mb-lg flex items-center text-body-xs', className)}
    >
      <p className="mr-sm whitespace-nowrap">{label}:</p>
      <p className="max-w-[15em] truncate font-bold">{value}</p>
    </div>
  );
}

FieldValue.displayName = 'FieldValue';
